module.exports = __webpack_public_path__ + "static/img/default-avatar.017b87bf.png";